export const TASKS_TYPES = {
  CALL: 'call',
  ACTIVITY: 'activity',
  MEETING: 'meeting',
}

export const TASK_TYPE_OPTIONS = [
  {
    key: 'call',
    text: 'Call',
    value: TASKS_TYPES.CALL,
  },
  {
    key: 'activity',
    text: 'Activity',
    value: TASKS_TYPES.ACTIVITY,
  },
  {
    key: 'meeting',
    text: 'Meeting',
    value: TASKS_TYPES.MEETING,
  },
]

export const TASKS_BOARD_VIEW_CARD_COLORS = {
  new: `rgb(30 144 255 / 33%)`,
  open: `rgb(30 144 255 / 66%)`,
  on_hold: `#1E90FF`,
  closed: `#4CAF50`,
  overdue: `#F44336`,
}

export const TASKS_DEFAULT_KAN_BOARD_DATA = {
  lanes: [
    {
      id: 'new',
      title: 'New',
      label: '0/0',
      cards: [],
    },
    {
      id: 'open',
      title: 'Open',
      label: '0/0',
      cards: [],
    },
    {
      id: 'on_hold',
      title: 'On Hold',
      label: '0/0',
      cards: [],
    },
    {
      id: 'closed',
      title: 'Closed',
      label: '0/0',
      cards: [],
    },
    {
      id: 'overdue',
      title: 'Overdue',
      label: '0/0',
      cards: [],
    },
  ],
}
